import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPost, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';

interface SkipResponse {
  skipped: true;
}

interface SkipVariables {
  logId: string;
  reason: string;
}

export function useAccountingSyncSkip() {
  const queryClient = useQueryClient();
  return useApiMutation<SkipResponse, SkipVariables>({
    mutationFn: ({ logId, reason }) =>
      apiPost<SkipResponse, { reason: string }>(
        operationsClient,
        settingsEndpoints.accountingSyncSkip(logId),
        { reason },
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: settingsKeys.accountingFailures() });
      void queryClient.invalidateQueries({ queryKey: settingsKeys.accountingDashboard() });
      toast.success('Marked as skipped');
    },
  });
}
